var map = {
	"./cannabis.svg": "33f0",
	"./cocaine.svg": "0856",
	"./gemstones.svg": "5f5a",
	"./heroin.svg": "9982",
	"./human.svg": "d96c0",
	"./ivory.svg": "88cb",
	"./minerals.svg": "2d24",
	"./rhino.svg": "9629",
	"./synthetic.svg": "c669",
	"./tiger.svg": "7491",
	"./timber.svg": "b88b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1e4b";